
















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	props: {
		isUp: Boolean,
	},
	setup() {
		return {};
	},
});
